import { stylesConfig } from "../helpers/stylesConfig";
import SignInUp from "./SignInUp/SignInUp";
import useDeviceType from "../hook/useDeviceType";
import { useLocation, useNavigate } from "react-router";
import SignInData from "./SignInUp/SignInData";
import Balance from "./SignInUp/components/Balance";
import { COMMON_ALT } from "../constant";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import ColorSwitcher from "../pages/MenuBar/components/colorSwitcher";
import IconCircleWrapper from "./Icon/IconCircleWrapper";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdOutlineLanguage } from "react-icons/md";
import { openLanguagePop } from "../redux/action/member/memberAction";
import { IoSearch } from "react-icons/io5";
import useCheckLogin from "../hook/useCheckLogin";
import HeaderAppDownload from "../pages/App/HeaderAppDownload";

const Header = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const i18n_header = (key) => t(`header.${key}`);

  const headerBg = useColorModeValue("light.100", "dark.100");
  const headerBgGradient = useColorModeValue(
    "--header-gradient.light",
    "--header-gradient.dark"
  );
  const signInColor = useColorModeValue("dark.100", "light.100");
  const headerBorder = useColorModeValue("", "dark.200");
  const { colorMode, toggleColorMode } = useColorMode();

  const { isLogin } = useCheckLogin();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation(); //返回一個location對象，其中包含當前URL的信息。它與window.location最大的區別是，它不會引起頁面重新加載。你可以在任何地方使用它，包括React Hooks組件中。

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const { pathname } = location; //取網址

  return (
    <Box
      width={`100%`}
      minHeight={{
        // sm: isLogin ? "76px" : "56px",
        // base: isLogin ? "70px" : "50px",
        sm: "56px",
        base: "50px",
      }}
      position="sticky"
      top="0px"
      left="0px"
      zIndex="999"
      display="flex"
      flexDirection={"column"}
      alignItems="center"
      justifyContent="space-between"
      className="header-shadow"
      // borderColor={headerBorder}
    >
      <HeaderAppDownload />
      <Flex
        // ml={{
        //   base: "0px",
        //   lg: isGameBox ? "0px" : "219px",
        // }}
        bg={headerBg}
        bgGradient="linear(to-b, header-gradient.from, header-gradient.to)"
        borderBottom={{
          md: "1px solid",
          base: "1px solid",
        }}
        style={{
          borderBottomColor: colorMode === "dark" ? "#000000" : "#cbd5e0",
        }}
        alignItems={`center`}
        justifyContent={`space-between`}
        pl={{
          md: "25px",
          base: "10px",
        }}
        pr={{
          md: "35px",
          base: "10px",
        }}
        width={`100%`}
        // maxWidth={{
        //   sm: "1024px",
        //   lg: "1440px",
        // }}
        height="100%"
        overflowY="hidden"
      >
        {" "}
        <Flex
          display={{
            base: "block",
            lg: isGameBox ? "block" : "none",
          }}
          alignItems={`center`}
          color="light.100"
        >
          <Box>
            <Link to="/">
              <Image //用三元運算 (? :) 去判斷 如果已登入就顯示 stylesConfig.loggedInLogo 圖片，否則顯示 stylesConfig.mainLogo 圖片
                src={stylesConfig.mainLogo}
                cursor={"pointer"}
                mr={{
                  base: "0px",
                  lg: "45px",
                }}
                ml={{
                  base: "0px",
                  lg: "25px",
                }}
                width={
                  isLogin
                    ? {
                        md: "80px",
                        base: "79px",
                      }
                    : {
                        md: "105px",
                        base: "79px",
                      }
                }
                pointerEvents={"all"}
                alt={COMMON_ALT}
              />
            </Link>
          </Box>
        </Flex>
        <Flex
          display={{
            base: "none",
            md: "block",
          }}
          alignItems={`center`}
          color="light.100"
        >
          <Box>
            <Link to="search">
              <InputGroup py="5px">
                <InputLeftElement pointerEvents="none">
                  <Icon as={IoSearch} color="gray.300" />
                </InputLeftElement>
                <Input
                  readOnly
                  type="text"
                  variant={`brandPrimary`}
                  borderRadius={`full`}
                  width={{
                    md: "150px",
                    lg: "200px",
                    xl: `500px`,
                    "2xl": "700px",
                  }}
                  bg="light.200"
                  placeholder="Search..."
                />
              </InputGroup>
            </Link>
          </Box>
        </Flex>
        {isLogin && (
          <Box
            display={{
              md: "none",
              base: "flex",
            }}
          >
            <Balance />
          </Box>
        )}
        <Flex alignItems={`center`} gap="15px" justifyContent={`flex-end`}>
          <Box //電腦版
            display={{
              md: "flex",
              base: "none",
            }}
            gap="15px"
            alignItems={`center`}
          >
            {/* <IconCircleWrapper
              divProps={{
                onClick: () => navigate("search"),
              }}
              className={`hidden md:flex min-h-[38px] min-w-[38px]`}
            >
              <BiSearch className="text-xl" />
            </IconCircleWrapper> */}
            <ColorSwitcher
              colorClassName="!text-white dark:!text-base-dark"
              wordHidden
            />
            <IconCircleWrapper
              divProps={{
                onClick: () => dispatch(openLanguagePop()),
              }}
              className={`hidden md:flex min-h-[38px] min-w-[38px]`}
            >
              <MdOutlineLanguage className="text-xl" />
            </IconCircleWrapper>
            {isLogin ? <Balance /> : <></>}
          </Box>
          {isLogin ? (
            <>
              <SignInData />
            </>
          ) : (
            <Flex gap="5px">
              <Link to="signin">
                <Button
                  variant={`brandPrimary`}
                  type="button"
                  bg="none"
                  fontWeight={`semibold`}
                  color={signInColor}
                  minWidth={`45px`}
                  fontSize="sm"
                >
                  {i18n_header("signin")}
                </Button>
              </Link>{" "}
              {window.open_registration == 1 && (
                <Link to="signup">
                  <Button
                    variant={`brandPrimary`}
                    type="button"
                    fontWeight={`semibold`}
                    color={`white`}
                    minWidth={`45px`}
                    fontSize={`sm`}
                  >
                    {i18n_header("signup")}
                  </Button>
                </Link>
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
